import { render, staticRenderFns } from "./CertificatePage.vue?vue&type=template&id=86511d2c"
import script from "./CertificatePage.vue?vue&type=script&lang=js"
export * from "./CertificatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports